import React from "react";

import { Icon } from "@braze/beacon-core";
import { getSemanticColor } from "@braze/beacon-styling";

import type { ComponentInvalidStatus, ComponentInvalidStatusIconProps } from "./types";

const mapStatusToSemanticColorType = (status: ComponentInvalidStatus) => {
  return status == "danger" ? "danger-icon-control" : "warning-icon-control";
};

const mapStatusToIcon = (status: ComponentInvalidStatus) => {
  return status == "danger" ? "exclamation-triangle" : "exclamation-circle";
};

export const ComponentInvalidStatusIcon = (props: ComponentInvalidStatusIconProps) => {
  return (
    <Icon
      className={props.status === "danger" ? "db-component-status-error" : "db-component-status-warning"}
      color={getSemanticColor(mapStatusToSemanticColorType(props.status))}
      name={mapStatusToIcon(props.status)}
      size="1x"
    />
  );
};
